import { DataBean } from "../../DataBean";


export class HealthMedicationCatalog extends DataBean {


    public async importHealthMedicationCatalog(filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importHealthMedicationCatalog_String_String_String", [filename, directory, dataStore]);
    }

}